// removed by extract-text-webpack-plugin
module.exports = {"pgx-report-share":"pgx-report-share","ant-modal-body":"ant-modal-body","share-info":"share-info","share-tips":"share-tips","share-item":"share-item","ant-form-item-label":"ant-form-item-label","ant-form-item-control-wrapper":"ant-form-item-control-wrapper","ant-input":"ant-input","share-btn":"share-btn","current-share-subtitle":"current-share-subtitle","content":"content","line":"line","subtitle":"subtitle","pgx-form-item":"pgx-form-item"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/ShareModal/shareModal.scss
// module id = 923
// module chunks = 0